import { Box, Button, LinearProgress, Typography } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import axios from "../axios";
import { useQuery } from "react-query";
import { useNavigate } from "react-router-dom";

const columns = [
  { field: "name", headerName: "Name", width: 180 },
  { field: "nic", headerName: "NIC", width: 150 },
  { field: "email", headerName: "Email", width: 220 },
  { field: "phone", headerName: "Phone", width: 150 },
  { field: "subjects", headerName: "Subjects", width: 200 },
  {
    field: "classes",
    headerName: "Assigned Classes",
    width: 250,
    valueGetter: (params) =>
      params.row.classes.map((c) => c.name).join(", ") || "None",
  },
];

const Teachers = () => {
  const navigate = useNavigate();
  const { data, isLoading } = useQuery("teachers", () =>
    axios.get("/teachers").then((res) => res.data)
  );
  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: "1.5rem",
        }}
      >
        <Typography variant="h5" component="h2">
          Teachers
        </Typography>
        <Button variant="contained" onClick={() => navigate("/teachers/new")}>
          New Teacher
        </Button>
      </Box>

      <Box sx={{ height: 650, width: "100%" }}>
        <DataGrid
          components={{
            LoadingOverlay: LinearProgress,
          }}
          loading={isLoading}
          rows={data || []}
          columns={columns}
          pageSize={10}
          rowsPerPageOptions={[10]}
          disableSelectionOnClick
        />
      </Box>
    </div>
  );
};

export default Teachers;
